module.exports = __webpack_public_path__ + "img/break-the-silence.9f23818e.png";